export function importAsset(path: string): string {
  const assets = import.meta.glob("~/assets/**/*.(png|svg|jpg|jpeg|webp)", {
    eager: true,
    import: "default",
  });
  // @ts-expect-error: wrong type info
  return assets["/assets/" + path];
}
